(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698],{

/***/ 24931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(69123);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12569);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80338);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88038);





var CareersPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var data = (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .useQuerySubscription */ .L)(subscription).data;
    if (!data) return null;
    var jobs = data.jobs, _page = data.page, title = _page.title, modules = _page.modules, seo = _page.seo;
    var _modules = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modules);
    // Create jobs section
    var items = jobs.map(function(param) {
        var id = param.id, title = param.title, slug = param.slug, parentPage = param.parentPage;
        return {
            id: id,
            title: title,
            internal: true,
            page: {
                slug: slug,
                parentPage: parentPage
            }
        };
    });
    var jobsSection = {
        items: items,
        _modelApiKey: _modules__WEBPACK_IMPORTED_MODULE_2__/* .MODULE_KEYS.resource */ .hc.resource,
        id: "narrative-current-openings",
        heading: "Current openings",
        headingSize: "h2",
        subheading: !items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: "Sorry, there are currently no openings available."
        }) : null,
        isSection: true,
        footer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-200 mt-15 mx-auto text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-4",
                    children: "Narrative is an equal opportunity workplace and we strongly believe that diversity is a major strength. Creating a diverse workplace is a constant battle in the tech industry but we are working as hard as we can to ensure our employment opportunities and workplace is as welcoming to all as possible. Everyone is welcome to apply to work at Narrative."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "We’re always looking for talented people, so if you don’t see your perfect role drop us an email anyway."
                })
            ]
        })
    };
    // Add the jobs section as the second to last module
    _modules.splice(_modules.length - 1, 0, jobsSection);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Layout */ .Ar, {
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SEO */ .HJ, {
                title: "".concat(title, " | Narrative"),
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_5__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_2__/* .ModuleToComponent */ .WT, {
                modules: _modules
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CareersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(24931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);